import React, {Component} from 'react'
import Modal from "../Modal";
import ChromeModalForm from "../../forms/file/ModalChromeForm";
import PropTypes from "prop-types";

class ChromeModal extends Component {
    render() {
        const {id, finishCallback} = this.props;

        return <Modal id={id}>
            {(closeModal) => (
                <ChromeModalForm closeModal={closeModal} finishCallback={finishCallback} />
            )}
        </Modal>
    }
}

ChromeModal.propTypes = {
    id: PropTypes.string.isRequired,
    finishCallback: PropTypes.func,
};

ChromeModal.defaultProps = {
    finishCallback: () => {},
};

export default ChromeModal